import React from 'react';
import XLSX from 'xlsx';

import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import PrintPdf from '../../utils/print/PrintPdf';
import Requisitions from '../../utils/requisitions/Requisitions';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Button from '../../components/buttons/Button';
const URL_LISTA = WS.relatorios.clientes;

//
class RelatoriosClientesNaoPagantes extends React.Component{
  constructor (props){
    super(props);

    const date = new Date();
    let firstDay = 1 +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();
    let today = date.getDate() +'/'+  (date.getMonth()+1) +'/'+  date.getFullYear();

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      dataInicial: firstDay,
      dataFinal: today,
      isLoading: true,
      data: [] /* Array of Arrays e.g. [["a","b"],[1,2]] */
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.printDiv = this.printDiv.bind(this);
    this.creatExcel = this.creatExcel.bind(this);
  }

  handleSubmit(e){
    const form = document.getElementById('form-data-adesao');
    const dti = form.querySelectorAll("[name='dti']")[0].value;
    const dtf = form.querySelectorAll("[name='dtf']")[0].value;
    this.loadData({dti, dtf});
    e.preventDefault();
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    this.loadData({});
  }

    loadData(_args_) {
      const {atencao} = this.state.strings;
      let _self = this;
      Requisitions({
        url: _self.props.url,
        data:_args_,
        sucess:function(data){
          var msg;

          _self.setState({
            lista: data.items,
            isLoading: false
          });

        },
        error:function(data){
          console.log(data);
        }
      });
    }

  getArrayExcel(){
    const arr = [];
    arr.push(["Nome", "E-mail", "Cpf"]);
    let lista = this.state.lista.map((value, i) => {
      arr.push([value.name,value.email,value.cpf_cnpj]);
    });
    return arr;
  }

  creatExcel(e){
    e.preventDefault();
    const arr = this.getArrayExcel();
    const ws = XLSX.utils.aoa_to_sheet(arr);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, "foco90.xlsx");
  }

  printDiv(e){
    e.preventDefault();
    var sWinHTML = document.getElementById('printable').innerHTML;
    PrintPdf.print(sWinHTML);
    return false;
  }

  render() {
    let lista = this.state.lista.map((value, i) =>
      <div className='item-relatorio' key={i}>
        <div className='item-relatorio__title'>{value.name}</div>
        <div className=''>Cpf: {value.cpf_cnpj}</div>
        <div className=''>E-mail: {value.email}</div>
        {/*}<div>Cliente desde: 00/00/0000</div>
      <div>Pagamento: boleto (00/00/0000)</div>*/}
      </div>
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }
    let wrapper = this.state.isLoading ? <LoadingPage /> : lista;
    const { dataInicio, dataFim, procurar } = this.state.strings;

    var date = new Date();
    var timestamp = date.getTime();

    return (
      <div>
        <div className="box-bt-export">
          <div className="pure-u-g">
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.printDiv}>Gerar pdf</a></div>
            </div>
            <div className="pure-u-1-2">
              <div className="inner-bt-export"><a href='#' className='btpagseguro' onClick={this.creatExcel}>Gerar excel</a></div>
            </div>
          </div>
          <br /><br />
        </div>
        <div  id="printable">
          <div className='title-relatorio'>{this.state.lista.length} {this.props.title}</div>
            {/*
              <div className=''>
              <form onSubmit={this.handleSubmit} id="form-data-adesao">
                <div className="pure-u-9-24">
                <DateRangePickerWrapper
                  key={timestamp}
                  dti={this.state.dataInicial}
                  dtf={this.state.dataFinal}
                   titleDateInicio={dataInicio}
                   titleDateFim={dataFim} />
                </div>
                <div className="pure-u-9-24">
                  <div className='box-button-search-date'><Button type="submit" text={procurar} classes="bt-save bt-blue" /></div>
                </div>
                <br /><br />
                </form>
              </div>
              */}
          {wrapper}
        </div>
      </div>
    );
  }
}

export default RelatoriosClientesNaoPagantes;



// WEBPACK FOOTER //
// ./src/classes/relatorios/RelatoriosClientesNaoPagantes.js